module.exports = __webpack_public_path__ + "img/Colorize02.60a06a21.png";